module.exports = __webpack_public_path__ + "images/gift/gift-colors.ef1072744266c549ac48e503744a78a4.svg";